import {Component} from '@angular/core';
import { ItemMenu } from "@bndes/bndes-ux4/bn-nav";
import { BnUsuarioService, Usuario} from '@bndes/bndes-ux4/bn-usuario';
import {Subscription} from "rxjs";
import {AppRole} from "./common/constants/app-role.constant";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  titulo = 'PAC Online';

  usuarioSubscription: Subscription;

  itensExibidos: ItemMenu[] = [];

  itens: ItemMenu[] = [
    {
      id: '0',
      titulo: 'Pesquisa de PACs',
      url: 'pesquisa-proposta',
      urlTarget: '_self',
      separador: false,
      classeIcone: 'fas fa-search-dollar'
    },
    {
      id: '1',
      titulo: 'Enviar Alteração Beneficiário',
      url: 'envio-aditivo',
      urlTarget: '_self',
      separador: false,
      classeIcone: 'fa-paper-plane-o'
    },
    {
      id: '2',
      titulo: 'Consultar Alteração Beneficiário',
      url: 'consulta-aditivo',
      urlTarget: '_self',
      separador: false,
      classeIcone: 'fa-file-text-o'
    },
    {
      id: '3',
      titulo: 'Analisar Alteração Beneficiário',
      url: 'analisa-aditivo',
      urlTarget: '_self',
      separador: true,
      classeIcone: 'fa-file-text-o'
    },
  ];

  constructor(
    private usuarioService: BnUsuarioService,
  ) {
  }

  ngOnInit(): void {
    this.usuarioSubscription = this.usuarioService.usuario$.subscribe(
      (usuario: Usuario) => {
        this.itensExibidos = [];

        this.itensExibidos.push(this.itens[0]);

        if (usuario.possuiPermissao(AppRole.AGENTE_FINANCEIRO)) {
          this.itensExibidos.push(this.itens[1]);
          this.itensExibidos.push(this.itens[2]);
        }

        if (usuario.possuiPeloMenosUmaPermissao([AppRole.BNDES_ANALISTA, AppRole.BNDES_GERENTE, AppRole.BNDES_CHEFE])) {
          this.itensExibidos.push(this.itens[3]);
        }
      }
    );
  }


  funcaoAbrirPerfil(event) {

  }

  get getItensMenu(): ItemMenu[] {
    return this.itensExibidos;
  }
}
